import{m as t}from"./chunk-HBP5N4FR.js";t();import{useEffect as m}from"react";var i=({duration:e,onDelete:s})=>{m(()=>{let o;return e&&(o=setTimeout(s,e)),()=>{clearTimeout(o)}},[e])};export{i as a};
//# sourceMappingURL=chunk-ANT3P3HL.js.map
